export enum DASHLET_MODE {
  LIBRARY = 'Library',
  REPORT = 'Report',
}
